import { FC, useEffect, useRef } from "react";
import videojs from "video.js";
import type Player from "video.js/dist/types/player";
import "video.js/dist/video-js.css";
import styled from "styled-components";

interface VideoPlayerProps {
  options: PlayerOptions;
}

interface PlayerOptions {
  autoplay?: boolean;
  controls?: boolean;
  responsive?: boolean;
  fluid?: boolean;
  loop?: boolean;
  aspectRatio?: "16:9" | "4:3" | "16:10" | string;
  sources: VideoSource[];
}

interface VideoSource {
  src: string;
  type: string;
}

export const VideoPlayer: FC<VideoPlayerProps> = (props) => {
  const { options } = props;
  const videoRef = useRef<HTMLDivElement | null>(null);
  const playerRef = useRef<Player | null>(null);

  useEffect(() => {
    if (!playerRef.current) return;

    playerRef.current.src(options.sources);
  }, [options.sources]);

  useEffect(() => {
    if (playerRef.current) return;

    const videoElement = document.createElement("video-js");

    videoElement.classList.add("vjs-big-play-centered");
    videoRef.current?.appendChild(videoElement);

    playerRef.current = videojs(videoElement, options);

    return () => {
      if (playerRef.current?.isDisposed()) return;

      playerRef.current?.dispose();
      playerRef.current = null;
    };
  }, []);

  return (
    <VideoContainer data-vjs-player>
      <div ref={videoRef}></div>
    </VideoContainer>
  );
};

const VideoContainer = styled.div`
  border-radius: 10px;
  border: 1px solid rgba(145, 158, 171, 1);
  overflow: hidden;
`;
